module.exports = __webpack_public_path__ + "img/scene2copysub.3e5aef0a.png";